import { render, staticRenderFns } from "./DuplicateEmployeeWorkingShiftsModal.vue?vue&type=template&id=45e3eb86"
import script from "./DuplicateEmployeeWorkingShiftsModal.vue?vue&type=script&lang=js"
export * from "./DuplicateEmployeeWorkingShiftsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports